// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","tablet-up":"(min-width: calc(768 * 1px))","footer":"ModalFooter_footer__e_sg-"};